import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { SettingsRoutePage } from "../app/settingsRoute";

export const Route = createFileRoute("/settings")({
  component: SettingsRoute,
});

function SettingsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <SettingsRoutePage search={search} />;
}
